import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { IStore } from '../../../../../reducers'
import {
  getLicenses,
  isLicenseValid,
  validLicenses,
} from '../../../../../reducers/userAccount/selectors/license'
import { getIsAuthorizing } from '../../../../../reducers/userAccount/selectors/credentials'
import Premium, { IPremiumProps } from './Premium'

const mapStateToProps = (state: IStore): IPremiumProps => ({
  isAuthorizing: getIsAuthorizing(state),
  isLicenseValid: isLicenseValid(state),
  licenses: getLicenses(state),
  validLicenses: validLicenses(state),
})

export default connect(mapStateToProps)(withTranslation()(Premium))
